import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitFirmwareModel } from '@apps-common/types/management/unit-firmware'

export const createUnitFirmware = async (model: IUnitFirmwareModel): Promise<IUnitFirmwareModel> =>
  axios.post(`/management/unitfirmware/addunitfirmware`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitFirmwareModel
}

export const useManagementCreateUnitFirmware = (notify?: boolean, onSuccess?: (data: IUnitFirmwareModel) => void) =>
  useMutation({
    mutationKey: ['createUnitFirmware'],
    mutationFn: ({ model }: Props) => createUnitFirmware(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created device firmware.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create device firmware, please try again.')
      }
    },
    throwOnError: false
  })
